// @flow
import React, {Component} from 'react';
import { connect } from 'react-redux';
import {
    changeCampaignPreferences,
    changeCampaignsOrder,
    countCampaigns,
    getCampaigns
} from '../../actions/campaigns';
import { getTablePage } from '../../helpers/functions';
import _ from 'lodash';
import Campaigns from '../../components/Campaigns/campaigns';

const listCampaigns = [
    {name: 'Campaign name', key: 'title'},
    {name: 'Description', key: 'description'},
    {name: 'Logo', key: 'picture'},
];

class ProductCampaignsHOC extends Component {
    componentDidMount() {
        this.props.getProductCampaigns({
            limit: this.props.rowsPerPage,
            order: listCampaigns[this.props.orderBy].key + ' ' + this.props.order.toUpperCase()
        });
        this.props.countCampaigns();
    }

    handlePageChange = (iconType) => {
        let newPage  = getTablePage(iconType, this.props.page,  this.props.total, this.props.rowsPerPage);
        this.props.changeCampaignPreferences({key: 'page', value: newPage});
    };

    handleRowsPerPage = (rowsPerPage) => {
        rowsPerPage = parseInt(rowsPerPage);
        let newTotalPages = _.ceil(this.props.total / rowsPerPage);
        let currentPage = this.props.page;
        if(parseInt(currentPage) > newTotalPages ){
            currentPage = newTotalPages;
        }

        this.props.changeCampaignPreferences({key: 'rowsPerPage', value: rowsPerPage});
        this.props.changeCampaignPreferences({key: 'page', value: currentPage});
    };

    handleRowSelect = (id) => {
        this.props.history.push('/campaigns/' + id)
    };

    onRequestSort = (payload) => {
        this.props.countCampaigns();
        this.props.changeCampaignsOrder(payload);
    };

    getListRows = () => {
        return this.props.campaigns
          .valueSeq().toArray().map(campaign => ({
              id: campaign.get('id'),
              data: [
                  campaign.get('title'),
                  campaign.get('description'),
                  campaign.get('picture') ? 'Uploaded' : undefined,
              ],
              campaign: `CAMPAIGNS` + campaign.id
          }))
    };

    render() {
        return (
          <Campaigns
            {...this.props}
            listRows={this.getListRows()}
            listColumns={listCampaigns}
            handlePageChange={this.handlePageChange}
            handleRowsPerPage={this.handleRowsPerPage}
            handleRowSelect={this.handleRowSelect}
            onRequestSort={this.onRequestSort}
          />
        );
    }
}

const mapStateToProps = state => ({
    campaigns: state.campaigns.get('campaigns'),
    fetching: state.campaigns.get('fetching'),
    total: state.campaigns.get('total') ?
      state.campaigns.get('total') : 0,
    page: state.campaigns.get('page'),
    rowsPerPage: state.campaigns.get('rowsPerPage'),
    order: state.campaigns.get('order'),
    orderBy: state.campaigns.get('orderBy'),
});

const mapDispatchToProps = dispatch => ({
    getProductCampaigns: (payload) => {
        dispatch(getCampaigns(payload))
    },
    countCampaigns: (payload) => {
        dispatch(countCampaigns(payload))
    },
    changeCampaignPreferences: (payload) => {
        dispatch(changeCampaignPreferences(payload))
    },
    changeCampaignsOrder: (payload) => {
        dispatch(changeCampaignsOrder(payload))
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(ProductCampaignsHOC);



// WEBPACK FOOTER //
// ./src/containers/Campaigns/campaignsHOC.js